import ControlKind from '../controlKind';
import ControlState from '../controlState';
import PageState from '../pageState';

export default (pages: PageState[], kind?: ControlKind): ControlState[] => {
  const fields: ControlState[] = [];

  pages.forEach((p) => {
    p.controls.forEach((ctrl) => {
      if (kind && ctrl.kind === kind) {
        fields.push(ctrl);
      }
    });
  });

  return fields;
};
